import { mainSiteUrl } from '@/mocks/categories';

export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative bg-foreground-900 rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-5">
            <div className="lg:col-span-2 relative h-[300px] md:h-[400px] lg:h-auto -mb-8 lg:-mb-0 lg:-my-8 lg:-ml-8">
              <img
                src="https://readdy.ai/api/search-image?query=Confident%20European%20entrepreneur%20woman%20in%20her%20thirties%20standing%20in%20bright%20warehouse%20space%20surrounded%20by%20international%20shipping%20boxes%20and%20parcels%2C%20arms%20crossed%20with%20satisfied%20smile%2C%20wearing%20smart%20casual%20blazer%20over%20white%20tee%2C%20natural%20warehouse%20lighting%20with%20large%20windows%2C%20authentic%20business%20owner%20portrait%2C%20genuine%20proud%20expression%2C%20e-commerce%20success%20story%20photography&width=800&height=1000&seq=testimonial-v2&orientation=portrait"
                alt="Отзыв о YOYBUY Spreadsheet"
                title="YOYBUY Spreadsheet отзыв клиента"
                className="w-full h-full object-cover object-center"
              />
            </div>

            <div className="lg:col-span-3 flex flex-col justify-center p-8 md:p-12 lg:p-14">
              <span className="text-accent-400 text-7xl md:text-8xl font-serif leading-none mb-4 opacity-50">&ldquo;</span>
              <blockquote className="text-lg md:text-xl lg:text-2xl text-background-50 font-heading font-medium leading-relaxed mb-6">
                YOYBUY Spreadsheet полностью изменил мой подход к заказам из Китая. Раньше я тратила часы на оформление каждого заказа, постоянно боялась ошибиться с размерами или цветами. Теперь просто заполняю таблицу — и всё. Экономия времени колоссальная, а ошибок практически нет. Рекомендую всем, кто заказывает товары из Китая регулярно.
              </blockquote>
              <div className="mb-6">
                <p className="text-background-50 font-bold text-sm">Анна Ковалева</p>
                <p className="text-background-50/60 text-xs">Владелец интернет-магазина, Москва</p>
              </div>
              <div>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-foreground-900 bg-accent-400 hover:bg-accent-300 rounded-full transition-colors whitespace-nowrap no-underline"
                >
                  Попробовать YOYBUY Spreadsheet
                  <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}